export default function capitalize<T extends string>(str: T): Capitalize<T> {
  return str.replace(/\b[a-z]/gi, function (char) {
    return char.toUpperCase();
  }) as Capitalize<T>;
}
